import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

/**
 * Tracks how many times SPA navigation has started, so requests fired on a
 * page the user has since left can be told apart from requests still relevant
 * to what's on screen (e.g. to skip a stale error toast for an abandoned call).
 */
@Injectable({ providedIn: 'root' })
export class NavigationGenerationService {
  private readonly router = inject(Router);
  private counter = 0;

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.counter += 1;
      }
    });
  }

  current(): number {
    return this.counter;
  }
}
